import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {PlacementReviewDomain} from '../models/models.lib';
import {ApiService} from '../api/api.service';
const { apiUrl } = environment;

export abstract class CasiPlacementReviewDomainService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(placement_review_id: number): void {
    this.fetch(placement_review_id).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(placement_review_id: number): Observable<PlacementReviewDomain[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/placement/review/domain/all/${placement_review_id}`))
      .pipe(
        map((response: any, i) => {
          return <PlacementReviewDomain[]>response;
        }),
        map(r => r.map(x => PlacementReviewDomain.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class PlacementReviewDomainService extends CasiPlacementReviewDomainService{
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(id: number) {
    return this.apiService.getHttpCall(`placement/review/domain/all/${id}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('placement/review/domain', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/domain/${id}`, dataItem, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`placement/review/domain/${id}`, 'destroy');
  }
}
